<app-field-label [label]="label"></app-field-label>: <app-field-value [field]="field"></app-field-value>